module.exports = __webpack_public_path__ + "img/vertical_6_4_3016.b8647b9b.png";